<template>
    <div>
        <el-form ref="form"
                 class="form"
                 :model="form"
                 :rules="rules"
                 label-width="50px">
            <el-row>
                <el-card class="box-card">
                    <div slot="header"
                         class="clearfix">
                        <span>医院基本信息</span>
                    </div>
                    <el-col :span="12">
                        <el-form-item label="医疗机构名称"
                                      label-width="110px"
                                      prop="mingcheng">
                            <el-input v-model="form.mingcheng" style="width:93%"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="简称" label-width="130px"
                        >
                            <el-input v-model="form.jiancheng"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="医疗机构类别" label-width="110px"
                        >
                            <el-input v-model="form.jigouleibie" style="width:93%"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="医疗机构等级" label-width="130px"
                        >
                            <el-input v-model="form.jigoudengji"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="行政级别" label-width="110px"
                        >
                            <el-input v-model="form.xingzhengjibie" style="width:93%"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="医疗机构地址" label-width="130px"
                        >
                            <el-input v-model="form.jigoudizhi"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="详细地址" label-width="110px"
                        >
                            <el-input v-model="form.xiangxidizhi" style="width:93%"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="医保定点" label-width="130px"
                        >
                            <el-radio-group v-model="form.isyibao">
                                <el-radio :label="1">是</el-radio>
                                <el-radio :label="0">否</el-radio>
                            </el-radio-group>
                        </el-form-item>
                    </el-col>
                </el-card>
            </el-row>
            <el-row>
                <el-col :span="12">
                    <el-card class="box-card">
                        <div slot="header"
                             class="clearfix">
                            <span>项目负责人</span>
                        </div>
                        <el-form-item label="姓名"
                                      label-width="110px"
                        >
                            <el-input v-model="form.fuzeren.xingming"></el-input>
                        </el-form-item>
                        <el-form-item label="电话"
                                      label-width="110px"
                        >
                            <el-input v-model="form.fuzeren.dianhua"></el-input>
                        </el-form-item>
                        <el-form-item label="邮件"
                                      label-width="110px"
                        >
                            <el-input v-model="form.fuzeren.email"></el-input>
                        </el-form-item>
                    </el-card>
                </el-col>
                <el-col :span="12">
                    <el-card class="box-card">
                        <div slot="header"
                             class="clearfix">
                            <span>项目联系人</span>
                        </div>
                        <el-form-item label="姓名"
                                      label-width="110px"
                        >
                            <el-input v-model="form.lianxiren.xingming"></el-input>
                        </el-form-item>
                        <el-form-item label="电话"
                                      label-width="110px"
                        >
                            <el-input v-model="form.lianxiren.dianhua"></el-input>
                        </el-form-item>
                        <el-form-item label="邮件"
                                      label-width="110px"
                        >
                            <el-input v-model="form.lianxiren.email"></el-input>
                        </el-form-item>
                    </el-card>
                </el-col>
                <el-col :span="12">
                    <el-card class="box-card">
                        <div slot="header"
                             class="clearfix">
                            <span>数据录入人员</span>
                        </div>
                        <el-form-item label="姓名"
                                      label-width="110px"
                        >
                            <el-input v-model="form.shujuluru.xingming"></el-input>
                        </el-form-item>
                        <el-form-item label="电话"
                                      label-width="110px"
                        >
                            <el-input v-model="form.shujuluru.dianhua"></el-input>
                        </el-form-item>
                        <el-form-item label="邮件"
                                      label-width="110px"
                        >
                            <el-input v-model="form.shujuluru.email"></el-input>
                        </el-form-item>
                    </el-card>
                </el-col>
                <el-col :span="12">
                    <el-card class="box-card">
                        <div slot="header"
                             class="clearfix">
                            <span>生信人员</span>
                        </div>
                        <el-form-item label="姓名"
                                      label-width="110px"
                        >
                            <el-input v-model="form.shengxin.xingming"></el-input>
                        </el-form-item>
                        <el-form-item label="电话"
                                      label-width="110px"
                        >
                            <el-input v-model="form.shengxin.dianhua"></el-input>
                        </el-form-item>
                        <el-form-item label="邮件"
                                      label-width="110px"
                        >
                            <el-input v-model="form.shengxin.email"></el-input>
                        </el-form-item>
                    </el-card>
                </el-col>
            </el-row>

            <el-card style="text-align:right">
                <el-form-item>
                    <el-button type="primary"
                               @click="onSubmit">保存
                    </el-button>
                    <el-button @click="onCancel">取消</el-button>
                </el-form-item>
            </el-card>
        </el-form>
    </div>
</template>

<script>
export default {
    data() {
        return {
            form: {
                mingcheng: '',
                jiancheng: '',
                jigoudizhi: '',
                xiangxidizhi: '',
                jigoudengji: '',
                jigouleibie: '',
                isyibao: 1,
                fuzeren: {
                    xingming: '',
                    dianhua: '',
                    email: '',
                },
                lianxiren: {
                    xingming: '',
                    dianhua: '',
                    email: '',
                },
                shujuluru: {
                    xingming: '',
                    dianhua: '',
                    email: '',
                },
                shengxin: {
                    xingming: '',
                    dianhua: '',
                    email: ''
                }
            },
            rules: {
                mingcheng: [
                    {required: true, message: '请输入医疗机构名称', trigger: 'blur'},
                ],
            }
        }
    },
    methods: {
        getData() {
            this.$http.get('/hospital/')
                .then(resp => {
                    if (resp.data.code == 1) {
                        this.form = resp.data.data
                    }
                })
                .catch((err) => {
                    console.log(err)
                    this.loading = false
                })
        },
        onSubmit() {
            this.$refs['form'].validate((valid) => {
                if (valid) {
                    this.$http.post('/hospital/edit/', this.form)
                        .then(resp => {
                                if (resp.data.code == 1) {
                                    this.$message({
                                        message: '提交成功！',
                                        type: 'success'
                                    })
                                } else if (resp.data.code == -1) {
                                    this.$message({
                                        message: resp.data.errors,
                                        type: 'error'
                                    })
                                }
                            }
                        )
                } else {
                    this.$message({
                        message: '请检查输入',
                        type: 'error'
                    })
                }
            })
        },
        onCancel() {

        }
    },
    mounted() {
        this.getData()
    }
};
</script>

<style scoped>
.form {
    padding-right: 20px;
}

.el-card {
    margin: 10px;
}
</style>
